import { Fragment, useCallback } from 'react';
import { Calendar, ExpCheckbox, Title } from 'components/elements';
import { monthDateRange, zonedDateTime, zonedMoment } from 'utils/timezone';
import { useDispatch, useSelector } from 'react-redux';
import {
  getAlerts,
  setAlertToShow,
  setSelectedDate,
} from 'redux/actions';
import { ALERT_PROTO_TYPES, ALERT_LABELS } from 'utils/constants';

const SelectedGameSidebar = () => {
  const dispatch = useDispatch();
  const {
    selectedDate,
    alertStatus: cellData,
    alertsToShow,
  } = useSelector((state) => state.notifications);

  const handleDateChange = (date) => {
    dispatch(setSelectedDate(date));
  };

  const handleVisibilityChange = (e) => {
    dispatch(setAlertToShow(e.target.name, e.target.checked));
  };

  const handlePickerChange = useCallback((year, month) => {
    const selected = zonedMoment(selectedDate);
    if (!(selected.year() === year && selected.month() + 1 === month)) {
      dispatch(
        setSelectedDate(
          zonedDateTime({ year, month: month - 1, day: 1, hour: 12 })
        )
      );
    }
    dispatch(getAlerts(monthDateRange(year, month)));
  }, [dispatch, selectedDate]);

  return (
    <Fragment>
      <Title mb={3}>Calendar</Title>
      <Calendar
        value={selectedDate}
        minimized={true}
        cellData={cellData}
        onChange={handleDateChange}
        onPickerChange={handlePickerChange}
        mb={4}
      />
      <Title mb={3}>Alerts to show</Title>
      {Object.values(ALERT_PROTO_TYPES).map((type) => (
        <ExpCheckbox
          key={type}
          label={ALERT_LABELS[type]}
          color={type}
          name={type}
          checked={alertsToShow[type]}
          onChange={handleVisibilityChange}
        />
      ))}
    </Fragment>
  );
};

export default SelectedGameSidebar;
